<footer>
  <div class="container text-center">
    <span
      >Copyright&nbsp;&#169;&nbsp;{{
        "2018&ndash;" + year
      }}&nbsp;Karl Kurzer</span
    >
  </div>
</footer>
